import { MouseEvent, useState } from 'react';

import { InfoSvg } from '../../../../../../shared/Assets/svgIcons';
import Copy from '../copy';
import Delete from '../delete';
import Archive from '../archive';
import Rename from '../rename';
import Actions from '../../Actions';

import { SkillProperties } from '../../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import { ProgramDataProperties } from '../../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';

interface SkillAreaAccordionItemActionsProps {
	item: SkillProperties;
}

export const SkillAcquisitionHeaderActions = ({ item }: SkillAreaAccordionItemActionsProps) => {
	const [openActions, setOpenActions] = useState<boolean>(false);

	const toggleActionsHandler = (event: MouseEvent<SVGSVGElement>) => {
		event.stopPropagation();
		setOpenActions(!openActions);
	};

	const closeActionsHandler = () => setOpenActions(false);

	return (
		<div className="skillAreaActions" onMouseLeave={closeActionsHandler}>
			<div className="icon">
				<InfoSvg onClick={toggleActionsHandler} />
				<div style={{ display: openActions ? 'flex' : 'none' }} className="adminActions">
					<Rename item={item} />
					<Copy item={item} />
					<Delete item={item} />
					<Archive item={item} />
				</div>
			</div>
		</div>
	);
};

export const SkillAcquisitionProgramActions = ({ data }: { data: ProgramDataProperties }) => {
	const [openActions, setOpenActions] = useState<boolean>(false);

	const toggleActionsHandler = (event: MouseEvent<SVGSVGElement>) => {
		event.stopPropagation();
		setOpenActions(!openActions);
	};

	const closeActionsHandler = () => setOpenActions(false);

	return (
		<div className="skillAreaActions" onMouseLeave={closeActionsHandler}>
			<div className="icon">
				<InfoSvg onClick={toggleActionsHandler} />
				<div style={{ display: openActions ? 'flex' : 'none' }} className="adminActions">
					<Actions data={data} />
				</div>
			</div>
		</div>
	);
};
